// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { IDS_abstract } from './../../abstract/SagaBase/Objects/IDS_abstract';
export class IDS extends IDS_abstract {}
